import script from "./MenuSnb.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSnb.vue?vue&type=script&setup=true&lang=js"

import "./MenuSnb.vue?vue&type=style&index=0&id=11b53a3c&lang=css"

const __exports__ = script;

export default __exports__